import React from "react";
import { Box, Typography, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import img from '../../../commom/Assets/images/image.png'
import background from '../../../style/images/circlebackground.png'

interface BoosterLoanCardProps {
  onActivateClick?: () => void;
}

const BoosterLoanCard: React.FC<BoosterLoanCardProps> = ({ onActivateClick }) => {
  const navigate = useNavigate();

  const handleActivateClick = () => {
    if (onActivateClick) {
      onActivateClick();
    }
    navigate('/boosterlending');
  };

  return (
    <Box
      className='booster-card'
      sx={{
        position: "relative",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        background: `url(${background})`,
        backgroundSize: 'contain',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
        width: '100%',
        padding: "26px 40px",
        color: "white",
        overflow: "hidden",
        borderRadius: "12px",
        minWidth: "300px",
      }}
    >
      {/* Left Content (Text and Illustration) */}
      <Box sx={{ display: "flex", alignItems: "center", gap: '30px' }}>
        {/* Illustration */}
        <Box
          component="img"
          src={img}
          alt="Booster Loan Illustration"
          sx={{ height: "120px", width: "165px", objectFit: 'contain' }}
        />

        {/* Text Content */}
        <Box>
          <Typography
            variant="body1"
            fontSize='24px'
            sx={{ fontWeight: "bold", marginBottom: "8px" }}
          >
            Activate Booster Loan
          </Typography>
          <Typography
            variant="body1"
            sx={{ fontSize: '14px', lineHeight: '1.5' }}
          >
            Invest Now, Pay Later with our Booster Loans! <br />
            Minimum $50 Loan Amount.
          </Typography>
        </Box>
      </Box>

      {/* Right Content (Button) */}
      <Button
        variant="contained"
        color="primary"
        onClick={handleActivateClick}
        endIcon={
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M11.6802 14.62L14.2402 12.06L11.6802 9.5" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M4 12.0601H14.17" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M12 4C16.42 4 20 7 20 12C20 17 16.42 20 12 20" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        }
        sx={{
          textTransform: "none",
          padding: "13px 38px",
          borderRadius: "50px",
          fontSize: '16px',
          fontWeight: 600,
          zIndex: 2,
          flexShrink: 0,
          whiteSpace: 'nowrap',
          '&:hover': {
            opacity: 0.9,
          },
        }}
      >
        Activate
      </Button>
    </Box>
  );
};

export default BoosterLoanCard;
